import { get } from 'lodash';
import { api } from 'utils/hooks/useApi';
import { IAddressBook } from './_types';

export const getAllAddressBook = (): Promise<IAddressBook[]> | boolean =>
  api()
    .get(`/portal-api/mdex/addressBook/getAll`)
    .then((response) => get(response, 'data'))
    .catch((error) => false);

export const synchronizeAddressBook = (): Promise<boolean> =>
  api()
    .get(`/portal-api/mdex/addressBook/synchronize`)
    .then((response) => true)
    .catch((error) => false);
